import { IPerformanceEvaluationOperation } from "models/PerformanceEvaluationOperationModel";
import { BaseService } from "./base.service";

class PerformanceEvaluationOperationInternal extends BaseService {
	getPerformanceEvaluationOperationList = async (): Promise<
		IPerformanceEvaluationOperation[]
	> =>
		this.callApi<IPerformanceEvaluationOperation[]>(
			`PerformanceEquationOperation/GetAll`,
			"GET"
		);
}

export const PerformanceEvaluationOperationService =
	new PerformanceEvaluationOperationInternal();
